/* global zxcvbn */

export function getZxcvbnResult(value, email, name) {
  const zxcvbnResult = zxcvbn(value, [email, name]);
  return zxcvbnResult;
}
